import {useEffect, useRef} from 'react';
import {EditorProps as LetroProps} from '@letrustech/letro';
import {useMobile} from 'utils/hooks';
import TextHighlighter, {
  HighlightedText,
} from 'containers/NewReviewed/components/TextHighlighter';

import styles from './Editor.module.scss';

export interface EditorProps {
  genre: string;
  title: string;
  text?: string;
  paragraphs?: LetroProps['paragraphs'];
  newParagraphs?: string[];
  highlights?: HighlightedText[];
  activityTitle?: string;
  hasParentId?: boolean;
  view?: string;
}

function Editor({
  title,
  genre,
  newParagraphs,
  highlights,
  activityTitle,
  hasParentId,
  view,
}: EditorProps): JSX.Element {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const {isMobile} = useMobile();

  function disableEditing() {
    const editorTitle = document.getElementById(
      'editor-title',
    ) as HTMLSpanElement | null;
    if (editorTitle) {
      editorTitle.innerHTML = title;
    }
  }

  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [title]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {!isMobile && (
          <>
            <b>
              Gênero Textual: <span>{genre}</span>
            </b>

            {view === 'geral' && (
              <b>
                {hasParentId ? 'Reescrita' : 'Escrita'}:{' '}
                <span>{activityTitle}</span>
              </b>
            )}
          </>
        )}

        {!!title.length && (
          <span
            id="editor-title"
            onInput={disableEditing}
            spellCheck={false}
            contentEditable
          >
            {title}
          </span>
        )}
      </div>

      {isMobile && <hr className={styles.divider} />}

      <div className={styles.editorContent}>
        <TextHighlighter
          newParagraphs={newParagraphs ?? []}
          highlights={highlights ?? []}
        />
      </div>
    </div>
  );
}

export default Editor;
